/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Failsafe: 在产品页加载后，如果不存在已打开的弹层、抽屉或搜索栏，则移除全局遮罩与滚动锁，避免移动端无法点击
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // 仅在产品页执行（根据 sections/product-template.liquid 的 data-section-type="product"）
    if (!document.querySelector('section[data-section-type="product"]')) return;

    var html = document.documentElement;
    var overlay = document.querySelector('.PageOverlay');

    function ensureInteractive() {
      try {
        // 检查是否有组件处于打开态
        var anyOpen = document.querySelector('.Modal[aria-hidden="false"], .Popover[aria-hidden="false"], .Drawer[aria-hidden="false"], #Search[aria-hidden="false"]');
        if (!anyOpen) {
          // 关闭遮罩
          if (overlay && overlay.classList && overlay.classList.contains('is-visible')) {
            overlay.classList.remove('is-visible');
          }
          // 解除滚动锁
          html.classList.remove('no-scroll');
          if (typeof disableBodyScroll === 'function') {
            try { disableBodyScroll(false, '[data-scrollable]'); } catch (e) {}
          }
        }
      } catch (e) { /* 安静失败，避免影响页面其它逻辑 */ }
    }

    // 在首屏渲染后的多个时间点执行，最大程度避免初始化过程中遗留的遮罩/滚动锁
    setTimeout(ensureInteractive, 500);
    setTimeout(ensureInteractive, 1500);
    setTimeout(ensureInteractive, 3000);
  });
})();
